module.exports = __webpack_public_path__ + "static/img/anxunu02.06a921d9.png";